import { useAppSelector } from "../../../common/state/hooks";
import { KeycloakClientFactory } from "../../../helper/keycloak/factory";

export const useLoginValidator = () => {
    const isAuthenticated = useAppSelector((state) => state.auth.authenticated);
    const keycloak = KeycloakClientFactory.getInstance();

    const validateLogin = (callback: Function, params: Array<any>) => {
        isAuthenticated ? callback(...params): keycloak.login();
    };

    return {
        validateLogin
    }
}